function toggleCountrySwitcher() {
    const countrySwitcher = document.querySelector('.dtc-navigation__country-switcher');
    countrySwitcher.classList.toggle('dtc-visible');
}
function toggleSearchBar() {
    const searchIcon = document.querySelector('.dtc-icon-search-wrapper');
    const closeIcon = document.querySelector('.dtc-icon-close-wrapper');
    const altSearchBar = document.querySelector('dtc-predictive-search');
    searchIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
    altSearchBar.classList.toggle('hidden');
}
document.addEventListener('DOMContentLoaded', function () {
    const toggleLocations = [...document.querySelectorAll('.dtc-toggle-locations')];
    const toggleSearchBarButton = document.querySelector('.hc-header__icon');
    toggleLocations.forEach((toggleLocation) => toggleLocation.addEventListener('click', toggleCountrySwitcher));
    toggleSearchBarButton.addEventListener('click', toggleSearchBar);
});
